import React from "react";
import SvgBookmarkIcon from "../icons/iconComponents/BookmarkIcon";
import bookmarkIcon from "../icons/bookmark.svg";
import {
    createRefetchContainer,
    createFragmentContainer,
    graphql,
} from "react-relay";
import DeleteBookmarkMutation from "../mutations/DeleteBookmarkMutation";

function Bookmark(props) {
    const user_Bookmark = props.user_Bookmark;
    const postId = props.postId;

    function onBookmarkClick(e) {
        e.preventDefault();

        let bookmarkId = e.target.dataset.id;

        // let bookmarkIdInt = atob(bookmarkId)
        // 	.split(":")
        // 	.pop();

        DeleteBookmarkMutation(postId, bookmarkId, () => {
            console.log("Deleted Bookmark!");
        });
    }

    return (
        <div>
            {user_Bookmark.simpleBookmark != null
                ? user_Bookmark.simpleBookmark.edges.map((edge, key) => (
                      <div key={key}>
                          {edge.node != null ? (
                              <>
                                  <img
                                      width={24}
                                      src={bookmarkIcon}
                                      data-id={edge.node.id}
                                      onClick={onBookmarkClick}
                                      key={key}
                                  />
                              </>
                          ) : null}
                      </div>
                  ))
                : null}
        </div>
    );
}

export default createRefetchContainer(Bookmark, {
    user_Bookmark: graphql`
        fragment Bookmark_user_Bookmark on PostNode
        @argumentDefinitions(post: { type: "ID" }) {
            simpleBookmark(post: $post, first: 1)
                @connection(key: "Bookmark_simpleBookmark", filters: []) {
                edges {
                    node {
                        id
                        is_bookmarked
                    }
                }
            }
        }
    `,
});
